import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { TextUIPart } from 'ai';
import { Edit as EditIcon } from '@vy/ui-design-system';
import { useAiCopilot } from '../context/use-ai-copilot';
import {
  chatHeaderCloseIcon,
  chatHeaderNewChatIcon,
  chatHeaderRoot,
  chatHeaderTitle,
  chatHeaderTitleGroup,
} from '../styles';

const TITLE_MAX_CHARS = 38;

function deriveChatTitle(messages: { role: string; parts: { type: string }[] }[]): string | null {
  const firstUser = messages.find((m) => m.role === 'user');
  if (!firstUser) return null;
  const text = firstUser.parts
    .filter((p): p is TextUIPart => p.type === 'text')
    .map((p) => p.text)
    .join(' ')
    .trim();
  if (!text) return null;
  return text.length > TITLE_MAX_CHARS ? `${text.slice(0, TITLE_MAX_CHARS).trimEnd()}…` : text;
}

export const ChatHeader: React.FC = () => {
  const { closeDrawer, clearChat, chat } = useAiCopilot();
  const hasMessages = chat.messages.length > 0;
  const chatTitle = deriveChatTitle(chat.messages);

  return (
    <Box sx={chatHeaderRoot}>
      <Box sx={{ ...chatHeaderTitleGroup, minWidth: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Typography sx={chatHeaderTitle} noWrap>
          {chatTitle ?? 'Insights Agent'}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
        {hasMessages && (
          <Tooltip title="New chat">
            <IconButton data-vy="ai-copilot-new-chat" onClick={clearChat} size="small" sx={chatHeaderNewChatIcon}>
              <EditIcon width={16} height={16} />
            </IconButton>
          </Tooltip>
        )}
        <IconButton data-vy="ai-copilot-close" onClick={closeDrawer} size="small">
          <CloseIcon sx={chatHeaderCloseIcon} />
        </IconButton>
      </Box>
    </Box>
  );
};
